<template>
    <div
        class="block-wrapper"
        style="position: fixed;"
        @click.stop
        @mousedown.stop
        @mouseup.stop
        @keydown.stop
        @keyup.stop
    >
        <v-card v-if="properties.type == 'success'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" >
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #3498DB; font-size: 20px;"   small text @click="closeAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'successWithCallback'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" >
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #3498DB; font-size: 20px;"   small text @click="acceptAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'question'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>

            <v-card-actions class="body_card" >
                <v-btn class="btn " style="background: #3498DB ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #E3191E;font-size: 20px;" dark small text @click="acceptAlert()">
                    Eliminar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'questionWithInnerHTML'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                <div v-html="properties.body">
                </div>
            </v-card-text>

            <v-card-actions class="body_card" >
                <v-btn class="btn " style="background: #3498DB ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #00A178;font-size: 20px;" dark small text @click="acceptAlert()">
                    Continuar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'questionDangerHtml'" class="dialog bg-danger dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert bg-danger">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card bg-danger dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;">
                <br/>
                <div v-html="properties.body"></div>
            </v-card-text>

            <v-card-actions class="body_card bg-danger">
                <v-btn class="btn " style="background: #FAFAFA ;font-size: 20px; color: #263238;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #B71C1C;font-size: 20px;" dark small text @click="acceptAlert()">
                    Continuar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'closeeSesion'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>

            <v-card-actions class="body_card" >
               
                <v-btn class="btn" style="background: #E3191E;font-size: 16px;" dark  text @click="acceptAlert()">
                    Cerrar 
                    <br/>
                    sesion 
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn " style="background: #3498DB ;font-size: 16px;"  text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Mantener 
                    <br/>
                    sesion
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'question2'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>

            <v-card-actions class="body_card">
                <v-btn class="btn " style="background: #3498DB ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #00A178;font-size: 20px;" dark small text @click="acceptAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'question3'" class="dialog bg-danger dialog-scrollable question3-dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert bg-danger">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card bg-danger dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;">
                <br/>
                <div v-html="properties.body"></div>
            </v-card-text>

            <v-card-actions class="body_card bg-danger dialog-scrollable-actions question3-actions">
                <v-btn class="btn dialog-action-btn" style="background: #FAFAFA ;font-size: 18px; color: #263238;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-btn class="btn dialog-action-btn" style="background: #FAFAFA;font-size: 18px; color: #263238;" dark small text @click="secondaryAlert()">
                    Continuar sin duplicados
                </v-btn>
                <v-btn class="btn dialog-action-btn" style="background: #B71C1C;font-size: 18px;" dark small text @click="acceptAlert()">
                    Continuar con todos
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'questionDanger'" class="dialog bg-danger dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert bg-danger">
                <v-icon>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
            </v-card-title>

            <v-card-text class="body_card bg-danger dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>

            <v-card-actions class="body_card bg-danger dialog-scrollable-actions">
                <v-btn class="btn dialog-action-btn" style="background: #FAFAFA ;font-size: 20px; color: #263238;" small text @click="statusAlert(false)"
                v-on:keydown.enter="statusAlert(false)"
                >
                    Cancelar
                </v-btn>
                <v-btn class="btn dialog-action-btn" style="background: #B71C1C;font-size: 20px;" dark small text @click="statusAlert(true)">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'danger'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #E3191E ; font-size: 20px;" small text @click="closeAlert()"
              
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'dangerHtml'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p> 
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #E3191E ; font-size: 20px;" small text @click="closeAlert()"
              
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'dangerStrong'" class="dialog dialog-scrollable danger-strong-dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert danger-strong-header" style="color: white;">
                <v-icon dark large class="mr-2">mdi-alert-octagon</v-icon>
                <span style="font-size: 22px; font-weight: 900;">{{ properties.header }}</span>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card danger-strong-body" style="font-weight: 500; color: whitesmoke; font-size: 22px; line-height: 1.5;">
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card danger-strong-actions" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #B71C1C; font-size: 20px; color: white; border: 2px solid #FFCDD2;" small text @click="closeAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'dangerHtmlDownload'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p>
                <br />
                <p style="color: white !important; font-size: 16px;">
                    Descargue el detalle a continuación:<br/>
                    <a @click="exportExcelOnClick( properties.options.fileTitle, properties.options.fileData )" >{{ properties.options.fileTitle }}.xlsx</a>
                </p>
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #E3191E ; font-size: 20px;" small text @click="closeAlert()"
              
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'strictValidation'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke !important;">
                <br/>
                {{ properties.body }}
                <v-checkbox color="white" class="whitesmoke-checkbox" v-model="strictValidation.flag" :label="properties.options.strictValidationLabel"/>
                <v-sheet v-if="!strictValidation.flag && strictValidation.count > 0"
                    color="red"
                    class="pa-3 rounded-lg white--text"
                    elevation="0"
                    style="
                        display: flex;
                        gap: 10px;
                    "     
                >
                    <div>
                        <v-icon class="white--text">
                            mdi-alert
                        </v-icon>
                    </div>
                    <div>
                        Por favor confirme que entiende las repercusiones de esta acción marcando la opción anterior.
                    </div>
                </v-sheet>
            </v-card-text>
            <v-card-actions class="body_card" >
                <v-btn class="btn " style="background: #E3191E ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #3498DB;font-size: 20px;" dark small text @click="strictValidationContinue()" :disabled="!strictValidation">
                    Continuar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'questionHtmlDownload'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p>
                <br />
                <p style="color: white !important; font-size: 16px;">
                    Descargue el detalle a continuación:<br/>
                    <a @click="exportExcelOnClick( properties.options.fileTitle, properties.options.fileData )" >{{ properties.options.fileTitle }}.xlsx</a>
                </p>
            </v-card-text>
            <!-- <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #E3191E ; font-size: 20px;" small text @click="closeAlert()"
              
                >
                    Aceptar
                </v-btn>
            </v-card-actions> -->
            <v-card-actions class="body_card" >
                <v-btn class="btn " style="background: #E3191E ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #3498DB;font-size: 20px;" dark small text @click="acceptAlert()">
                    Continuar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'questionHtmlBulkDownload'" class="dialog" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p>
                <br />
                <template v-if="properties.options.filesPools && properties.options.filesPools.length > 0">
                    <p style="color: white !important; font-size: 16px;">
                        {{ properties.options.downloadLabel || 'Descargue el detalle a continuación:' }}
                    </p>
                    <p style="color: white !important; font-size: 16px;" v-for="( filesPool, index ) in properties.options.filesPools" :key="`${ filesPool.file_pool_name }${ index }`" >
                        {{ filesPool.file_pool_name }}
                        <ul>
                            <li v-for="( file, index ) in filesPool.recordsets" :key="`${ file.name }${ index }`" >
                                <a @click="downloadAlertFile(file)" >{{ getAlertFileLabel(file) }}</a>
                            </li>
                        </ul>
                    </p>
                </template>
            </v-card-text>
            <v-card-actions class="body_card" >
                <v-btn class="btn " style="background: #E3191E ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="btn" style="background: #3498DB;font-size: 20px;" dark small text @click="acceptAlert()">
                    Continuar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="properties.type == 'warning'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
            @keyup.enter="funct()"
        >
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;"   @keyup.enter="funct()"
            >
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #F29D35  ; font-size: 20px;" small text  @keyup.enter="closeAlert()" @click="closeAlert()"
               
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>


        <v-card v-if="properties.type == 'successHtml'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" >
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp;<span v-html="properties.header"></span>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;">
                <br/>
               
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p> 
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
               
                <v-btn class="btn" style="background: #3498DB; font-size: 20px;"   small text @click="closeAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'warningHtml'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
            @keyup.enter="funct()"
        >
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;"   @keyup.enter="funct()"
            >
                <br/>
                {{ properties.body }}
              <!--   <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p> -->
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn " style="background: #3498DB ;font-size: 20px;" small text @click="acceptAlert()"
               
                >
                    Ver detalles
                </v-btn>
                <v-btn class="btn" style="background: #F29D35  ; font-size: 20px;" small text  @keyup.enter="closeAlert()" @click="closeAlert()"
               
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'tableSummaryHtml'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" style="color: white;">
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;font-size: 20px;">
                <br/>
                <p style="color: white !important; font-size: 16px;" v-html="properties.body"></p>
            </v-card-text>
            <v-card-actions class="body_card" style="align-items: center; justify-content: center;">
                <v-btn class="btn" style="background: #F29D35; font-size: 20px;" small text @keyup.enter="closeAlert()" @click="closeAlert()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-if="properties.type == 'progress'" class="dialog dialog-scrollable" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <v-card-title class="header_alert" >
                <v-icon dark>mdi-alert-circle</v-icon> &nbsp; {{ properties.header }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="body_card dialog-scrollable-body" style="font-weight: bold; color: whitesmoke;">
                <br/>
                {{ properties.body }}
            </v-card-text>
            <v-card-actions class="body_card">
                <v-btn class="btn " style="background: #3498DB ;font-size: 20px;" small text @click="closeAlert()"
                v-on:keydown.enter="closeAlert()"
                >
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import { exportExcel } from '../helpers/excel';
    export default {
        name: "Alerts",
        props: ['properties'],
        mounted() {
            setTimeout( () => {
                window.addEventListener('keyup', this.handleKeyUp);
            }, 200 );
        },
        data(){
            return {
                strictValidation: {
                    flag: false,
                    count: 0,
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.handleKeyUp);
        },
        methods: {
            strictValidationContinue() {
                if( !this.strictValidation.flag ) {
                    console.log( 'entro' )
                    this.strictValidation.count++;
                    return;
                }
                this.acceptAlert();
            },
            exportExcelOnClick( x='', data ) {
                exportExcel( x, data );
            },
            downloadAlertFile(file) {
                if (file && typeof file.onDownload === 'function') {
                    file.onDownload();
                    return;
                }

                this.exportExcelOnClick(file?.name, file?.data);
            },
            getAlertFileLabel(file) {
                const extension = file?.extension || 'xlsx';
                return `${file?.name}.${extension}`;
            },
            async closeAlert(){
                this.$emit('close_alert', false);
            },
            async acceptAlert(){
                this.$emit('accept_alert', false);
            },
            async secondaryAlert(){
                this.$emit('secondary_alert', false);
            },
            async statusAlert(val){
                this.$emit('status_alert', val);
                if (this.properties.resolve) {
                    this.properties.resolve(val);
                    this.properties.resolve = null;
                }
            },
            funct(){
                console.log("hola");
            },
            handleKeyUp(e) {
                const { type } = this.properties;
                if (e.key === 'Enter') {
                    type === 'successWithCallback' ? this.acceptAlert() : this.closeAlert();
                }
            },
        }
    };
</script>

<style scoped>
::v-deep .whitesmoke-checkbox.theme--light .v-label {
    /* font-weight: normal; */
    color: whitesmoke !important;
}

::v-deep .whitesmoke-checkbox.theme--light .v-icon {
    /* font-weight: normal; */
    color: whitesmoke !important;
}

.block-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffffa6;
        z-index:  20000000;
    }

.dialog{
    width: 600px;
    border-radius: 15px;
    z-index:  20000 !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

}

.question3-dialog {
    width: 700px;
    max-width: calc(100vw - 32px);
}

.dialog-scrollable-body {
    overflow-y: auto;
    max-height: calc(90vh - 160px);
}

.dialog-scrollable-actions {
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
}

.question3-actions {
    flex-wrap: nowrap;
}

.dialog-action-btn {
    margin: 0 !important;
    min-width: 140px;
    width: auto !important;
    max-width: 100%;
    height: auto !important;
    min-height: 40px;
    white-space: normal;
    line-height: 1.15;
}

.header{
    border-bottom: solid green;
    background: white;
    color: black;
    font-size: 20px;
    padding: 10px;
}

.body_card{
    background: #41464C;
    color: whitesmoke;

}

.footer{
    background: green;
    color: black;
    font-size: 16px;
    padding: 10px;
}

.button{
    background: white;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 8px;
    padding-right: 8px;
}
.header_alert{
    background:#41464C;
    color: whitesmoke;
}
.btn{
    color: whitesmoke;
    width: 140px;
    height: 40px !important;
    margin: 20px;
}
.bg-danger {
    background:#E3191E;
}

.danger-strong-dialog {
    width: 660px;
    max-width: calc(100vw - 32px);
    border: 1px solid #b71c1c;
    box-shadow: 0 18px 40px #b71c1c;
}

.danger-strong-header {
    background: #b71c1c;
    min-height: 72px;
}

.danger-strong-body {
    background: #e3191e;
}

.danger-strong-actions {
    background: #b71c1c;
}
/*
colores
#00A178 Verde
#F29D35 Naranja
#E3191E rojo
#3498DB Celeste
#41464C gris
*/
</style>
